/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ImaginePayBalanceIntegrationViewModel {
  /**
   * Dataset Id
   */
  datasetId?: string;
  /**
   * Patient Id
   */
  patientId?: string;
  /**
   * Patient Account Number
   */
  accountNumber?: number;
  /**
   * ImaginePay Online Account Number
   */
  onlineAccountNumber?: string | null;
  /**
   * Current patient balance sent to ImaginePay
   */
  patientAmountSent?: number;
  /**
   * ImaginePay Request ID
   */
  paymentRequestId?: string | null;
  /**
   * Timestamp for last balance update sent to ImaginePay (UTC)
   */
  paymentLastUpdated?: string | null;
  /**
   * Message
   */
  message?: string | null;
}
